import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerProfile } from '../api/services/customerService';

/**
 * Custom hook to check if the logged-in user is a guest
 * @returns {Object} { isGuestUser: boolean, isLoading: boolean }
 */
export const useGuestCheck = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const [isGuestUser, setIsGuestUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        setIsLoading(true);
        if (userInfo.idCustomer) {
          const profileResult = await getCustomerProfile(userInfo.idCustomer);
          if (profileResult?.data?.role === 'Guest') {
            setIsGuestUser(true);
          } else {
            setIsGuestUser(false);
          }
        } else {
          setIsGuestUser(false);
        }
      } catch (error) {
        console.error('Error checking user role:', error);
        setIsGuestUser(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkUserRole();
  }, [userInfo.idCustomer]);

  return { isGuestUser, isLoading };
};
